module.exports = __webpack_public_path__ + "img/wallet-more-active.cd9a10c2.png";